import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getProviderProfileDetailAction,
  getStaffDetailPopupAction,
} from "../../../redux/actions/ProviderProfileDetailAction";
import { getNetworkMenuId } from "../../../Utils/types";
import { ApproveRejectButton, initialFilterState } from "./helper";

export const StaffDetailsPopup = ({
  rowData,
  searchFilter,
  apiParams,
  setRowData,
}) => {
  const dispatch = useDispatch();
  const [remark, setRemark] = useState("");
  const getViewDetailPage = useSelector(
    (state) => state?.providerPortalDetailReducer?.getViewDetailPage
  );

  useEffect(() => {
    dispatch(getStaffDetailPopupAction(rowData?.requestID, rowData?.sessionID));
  }, []);

  return (
    <>
      <div className="___parent_container d-flex justify-content-between border-bottom modalHeader">
        <div className="d-flex align-items-center gap-10">
          <div className="logo-circle">
            <img src={rowData?.providerLogo} alt="" />
          </div>
          <div className="brand-name">
            <h5 className="mb-0 text-highlight font-bold">
              {rowData?.providerName}
            </h5>
          </div>
        </div>
        <div className="align-items-center gap-3 d-flex">
          {getViewDetailPage?.source && <h5 className="mb-0 text-highlight font-bold">
            <span style={{color:"black"}}>Action : </span>{getViewDetailPage?.source}
          </h5>}
          <button
          type="button"
          className="btn-close normal-close"
          onClick={async () => {
            await setRemark("");
            await setRowData(null);
            if (!Object.keys(getViewDetailPage).length) {
              await dispatch(
                getProviderProfileDetailAction(initialFilterState)
              );
            }
          }}
        ></button>
        </div>
      </div>
      <div className="modal-body">
        <h4
          className="font-bold text-highlight"
          style={{ letterSpacing: "1px" }}
        >
          Staff Details
        </h4>
        <div className="d-flex justify-content-between">
          <h5 className="font-bold text-black bottom-spacing-20 mt-4 mb-3">
            Network
          </h5>
        </div>
        <div className="table-responsive __custom__properties">
          <table className="table">
            <thead>
              <tr>
                <th scope="col">Contact Type</th>
                <th scope="col">Designation</th>
                <th scope="col">Contact Person</th>
                <th scope="col">Mobile Number</th>
                <th scope="col">Alternate Mobile Number</th>
                <th scope="col">Email ID</th>
              </tr>
            </thead>
            <tbody>
              {getViewDetailPage?.networksEmployees?.map((ele) => {
                return (
                  <tr>
                    <td>{ele?.subdivision}</td>
                    <td>{ele?.designation}</td>
                    <td>{ele?.employeeName}</td>
                    <td>{ele?.primaryContactNumber}</td>
                    <td>{ele?.alternativeContactNumber}</td>
                    <td>{ele?.emailAddress}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
        <h5 className="font-bold text-black bottom-spacing-20 mt-4 mb-3">
          Operations
        </h5>
        <div className="table-responsive __custom__properties">
          <table className="table">
            <thead>
              <tr>
                <th scope="col">Contact Type</th>
                <th scope="col">Designation</th>
                <th scope="col">Contact Person</th>
                <th scope="col">Mobile Number</th>
                <th scope="col">Alternate Mobile Number</th>
                <th scope="col">Email ID</th>
              </tr>
            </thead>
            <tbody>
              {getViewDetailPage?.operationsEmployees?.map((ele) => {
                return (
                  <tr>
                    <td>{ele?.subdivision}</td>
                    <td>{ele?.designation}</td>
                    <td>{ele?.employeeName}</td>
                    <td>{ele?.primaryContactNumber}</td>
                    <td>{ele?.alternativeContactNumber}</td>
                    <td>{ele?.emailAddress}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
        <div className="remarks mt-4 mb-5">
          <h5 className="font-bold text-black bottom-spacing-20 mb-3">
            Remarks
          </h5>
          <textarea
            className="textarea font-medium"
            placeholder="Type Something Here..."
            onChange={(e) => setRemark(e.target.value)}
            value={
              rowData?.requestStatus !== "Pending for Approval"
                ? rowData?.remarks
                : remark
            }
            disabled={
              rowData?.requestStatus !== "Pending for Approval" ||
              !getNetworkMenuId()?.canEdit
            }
          ></textarea>
        </div>
        <div className="accept-reject-btns bottom-0">
          {rowData?.requestStatus === "Pending for Approval" &&
            getNetworkMenuId()?.canEdit && (
              <ApproveRejectButton
                rowData={rowData}
                setRowData={setRowData}
                remark={remark}
                setRemark={setRemark}
                searchFilter={searchFilter}
                apiParams={apiParams}
              />
            )}
        </div>
      </div>
    </>
  );
};
